import { gql } from '@apollo/client';

import { subjectsTreeFragment } from '../fragments';

export default gql`
  mutation CreateSubject($courseId: String!, $input: CreateSubjectInput!) {
    subjects(courseId: $courseId, input: $input) @rest(type: "Subject", path: "courses/{args.courseId}/subjects", method: "POST") {
      ...SubjectsTree
    }
  }
  ${subjectsTreeFragment}
`;
